import { Divider, Typography } from "@mui/material";

import CustomRating from "../../../../Common/Rating/read-only-rating/CustomRating";
import { getInNetworkColor } from "../../helper/functions";
import { STYLES } from "../../utils/customStyles";
import STRINGS from "../../utils/strings";

export default function ProviderHeader({ data = {} }) {
  const { name, inNetwork, receivingClients, rating } = data;
  const [badgeBgColor, badgeTextColor] = getInNetworkColor(inNetwork, receivingClients);

  return (
    <div className="flex w-full flex-col gap-4 p-4" style={STYLES.container}>
      <Typography sx={STYLES.providerName}>{name}</Typography>

      <div className="flex flex-wrap items-center gap-2">
        <Typography sx={STYLES.locationText}>Location</Typography>

        <div
          className="px-4 py-1"
          style={{
            ...STYLES.statusBadge,
            backgroundColor: badgeBgColor,
          }}
        >
          <Typography sx={{ color: badgeTextColor }}>
            {STRINGS.NETWORK_STATUS_TYPE[inNetwork]}
          </Typography>
        </div>

        <Divider orientation="vertical" flexItem />

        <CustomRating value={rating} />
      </div>
    </div>
  );
}
